import React, { useEffect, useState, useContext } from "react";
import { useAuth } from "../../../context/API_Client";
import { Checkbox, FormControl, MenuItem, Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from "@mui/material";
import { styled } from '@mui/material/styles';
import OfferManagementContext from "../../../context/offerManagement.context";
import { isEmpty } from "../../../pages/utils/utils";
import _ from "lodash";
import { useLocation } from "react-router-dom";
import "./emiPlans.css"

const SelectField = ({
    label,
    value,
    onChange,
    options,
    placeholder,
    selectLabelId,
    selectId,
    margin,
    disabled
}) => (
    <div style={{ flexBasis: "50%", margin: margin }}>
        <Typography className="offerDetailsFieldTitle">{label}</Typography>
        <FormControl style={{ marginTop: "12px", width: "100%" }}>
            <Select
                labelId={selectLabelId}
                id={selectId}
                value={value}
                onChange={onChange}
                disabled={disabled}
                className="menuItemStyle"
                sx={{ width: "100%" }}
                renderValue={(selected) => (
                    <div className="itemNameStyling">
                        {selected
                            ? options?.find((item) => item.brand === selected)?.title
                            : placeholder}
                    </div>
                )}
                displayEmpty
            >
                {options?.map((item, idx) => (
                    <MenuItem
                        key={idx}
                        value={item?.brand}
                        className="menuItemStyle"
                    >
                        {item?.title}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    </div>
);
const StyledTableCell = styled(TableCell)(({ theme }) => ({
    padding: '8px 16px',
    backgroundColor: theme.palette.grey[200],
    color: theme.palette.grey[800],
    color: "var(--Global - Neutral - Grey - 1300, #0A090B)",
    fontFamily: "Poppins",
    fontSize: "14px",
    fontWeight: 500,
}));

const StyledTableHeadRow = styled(TableRow)(({ theme }) => ({
    borderBottom: '2px solid #E0E0E0',
    '& .MuiTableCell-root': {
        borderRight: `1px solid ${theme.palette.divider}`,
        '&:last-child': {
            borderRight: 'none',
        },
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({}));

export default function EmiPlans({ setIsNextButtonDisabled }) {
    const { offerFieldData,
        setOfferFieldData,
        emiPlanTableData,
        emiTypeOptions,
        issuerOptions,
        setIssuerOptions,
        emiData,
        setEmiData,
        OFFER_TYPE,
        offerDetailsById,
        allIssuerRef,
        setErrorMsz,
        setShowModal
    } = useContext(OfferManagementContext);

    const location = useLocation();
    const { type = 'create' } = location.state?.editData || {};

    const handleCheckboxChange = (duration, e, checked) => {
        e.stopPropagation();
        let index = emiData.findIndex(m => m.emiMethod.duration === duration);
        setEmiData(prev => {
            prev[index].isChecked = checked;
            return [...prev]
        })
    };
    useEffect(() => {
        if (isEmpty(emiData)) return setIsNextButtonDisabled(true);
        let isAnyOneChecked = emiData.some(i => i.isChecked && !isOfferAlreadyActive(i));
        setIsNextButtonDisabled(!isAnyOneChecked);
    }, [emiData]);
    const handleSelectChange = (duration, field, e) => {
        let index = emiData.findIndex(m => m.emiMethod.duration === duration);
        let value = e.target.value;
        if (isEmpty(value) || isNaN(value)) {
            setEmiData(prev => {
                prev[index][field] = value;
                prev[index].emiMethod.merchantBorneInterestRate = value === 'NoCostEmi' ? prev[index].emiMethod.interestRate : 0;
                return [...prev]
            })
        }
    };
    const handleTextFieldBlur = (duration, field, e) => {
        // handle grabage intrest values and set it "0"
        let index = emiData.findIndex(m => m.emiMethod.duration === duration);
        let value = e.target.value;
        setEmiData(prev => {
            prev[index].emiMethod.isPercentageAdded = true;
            return [...prev]
        })
        if (value.endsWith(".")) {
            value = value.split('.')[0]; // ex 13.1 -> 13
            setEmiData(prev => {
                prev[index].emiMethod[field] = value;
                return [...prev]
            })
        }
        if (isEmpty(e.target.value) || isNaN(e.target.value)) {
            setEmiData(prev => {
                prev[index].emiMethod[field] = 0;
                return [...prev]
            })
        }
    };
    const handleTextFieldFocus = (duration, field, e) => {
        let index = emiData.findIndex(m => m.emiMethod.duration === duration);
        setEmiData(prev => {
            prev[index].emiMethod.isPercentageAdded = false;
            return [...prev]
        })

    }
    const handleTextFieldChange = (duration, field, e) => {
        let value = e.target.value;
        value = value.replace(/[^0-9.]/g, "");
        const parts = value.split(".");
        if (parts.length > 2) {
            value = parts[0] + "." + parts[1]; // Remove additional decimals
        }
        if (parts[1]?.length > 2) {
            value = `${parts[0]}.${parts[1].substring(0, 2)}`;
        }
        value = value.replace(/^0+(?!\.)/, "0"); // remove leading zeros

        // Check if the value starts with a zero (but is not just "0") and remove it
        if (value !== "0" && value.startsWith("0")) {
            value = value.replace(/^0+/, "");
        }
        let index = emiData.findIndex(m => m.emiMethod.duration === duration);
        if (value > emiData[index].emiMethod.interestRate) {
            value = emiData[index].emiMethod.interestRate
        }
        e.target.value = value;
        if (index != -1) {
            setEmiData(prev => {
                prev[index].emiMethod[field] = e.target.value;
                return [...prev]
            })
        }
    };
    useEffect(() => {
        if ((isEmpty(offerFieldData?.selectedEmiOption) || isEmpty(offerFieldData?.selectedIssuer))) return setIsNextButtonDisabled(true);
        const filtered = emiPlanTableData?.filter((item) => {
            return (!offerFieldData?.selectedEmiOption || item?.emiMethod?.brand === offerFieldData?.selectedEmiOption) && (!offerFieldData?.selectedIssuer || item?.emiMethod?.issuer === offerFieldData?.selectedIssuer)
        });

        // set values on edit
        filtered.forEach(m => {
            if (!isEmpty(offerFieldData?.applicableOffer)) {
                let applicableOffer = offerFieldData?.applicableOffer.filter(d => d?.duration === m?.emiMethod?.duration)[0];
                if (!isEmpty(applicableOffer)) {
                    m.emiMethod['applicableOffer'] = applicableOffer
                }
            }

            m.emiMethod['isPercentageAdded'] = true;
            if (!isEmpty(m?.emiMethod?.applicableOffer)) {
                m.emiMethod.merchantBorneInterestRate = m?.emiMethod?.applicableOffer?.discount?.percentage;
                m.offerType = m?.emiMethod?.applicableOffer?.discount?.type;
            } else {
                m.emiMethod.merchantBorneInterestRate = m?.emiMethod?.interestRate;
                m.offerType = 'NoCostEmi';
            }
            if (type !== 'create') {
                m.isChecked = !isEmpty(m?.emiMethod?.applicableOffer)
            }
        })
        // const uniqueArray = _.uniqBy(filtered, "emiMethod.duration");
        const sortedArray = _.orderBy(filtered, ["emiMethod.duration"], ["asc"]);

        setEmiData(sortedArray);
        setIsNextButtonDisabled(false);
    }, [offerFieldData.selectedEmiOption, offerFieldData.selectedIssuer]);

    const handleEmiOptionChange = (e) => {
        let issuer = allIssuerRef.current.filter(d => d.emiType === e.target.value);
        if (isEmpty(issuer)) {
            setErrorMsz(`No Issuer found for ${e.target.value}`);
            return setShowModal(true)
        } else {
            setErrorMsz(``);
        }
        setIssuerOptions([...issuer])
        setOfferFieldData((prev) => (
            { ...prev, selectedEmiOption: e.target.value, selectedIssuer: '' }
        ));
    }
    const isFieldDisabled = (row) => row?.offerType === 'NoCostEmi' || !row?.isChecked;

    const isOfferAlreadyActive = (row) =>
        !isEmpty(row?.emiMethod?.applicableOffer) &&
        offerDetailsById.code !== row?.emiMethod?.applicableOffer?.code &&
        (isEmpty(offerDetailsById) || offerDetailsById?.status?.toUpperCase() === 'ACTIVE');

    const isEdit = type === 'edit';

    return (
        <div style={{ marginLeft: "36px", marginRight: "36px" }}>
            <div style={{ display: "flex", alignItems: "center", marginBottom: "28px" }}>
                <SelectField
                    label="Emi Options*"
                    value={offerFieldData?.selectedEmiOption || ''}
                    onChange={(e) => handleEmiOptionChange(e)}
                    disabled={isEdit}
                    options={emiTypeOptions}
                    placeholder="Select EMI Option"
                    selectLabelId="emi-options-select-label"
                    selectId="emi-options-select"
                    margin="0 1rem 0 0"
                />
                <SelectField
                    label="Issuer*"
                    value={offerFieldData?.selectedIssuer || ''}
                    onChange={(e) => {
                        setOfferFieldData((prev) => ({ ...prev, selectedIssuer: e.target.value }));
                    }}
                    disabled={isEdit || isEmpty(offerFieldData?.selectedEmiOption)}
                    options={issuerOptions.sort((a, b) => a.title.localeCompare(b.title))}
                    placeholder="Select Issuer Bank"
                    selectLabelId="issuer-select-label"
                    selectId="issuer-select"
                    margin="0 0 0 1rem"
                />
            </div>
            {
                isEmpty(emiData) ?
                    <>
                        {
                            offerFieldData?.selectedEmiOption && offerFieldData?.selectedIssuer && (
                                <div className="noDataDiv">
                                    <Typography className="noDataToDisplay">No EMI Options Available</Typography>
                                    <Typography className="noDataSubText"> Please choose a different EMI type or issuer to see available options.</Typography>
                                </div>
                            )
                        }
                        {
                            (isEmpty(offerFieldData?.selectedEmiOption) || isEmpty(offerFieldData?.selectedIssuer)) && (
                                <div className="noDataDiv">
                                    {/* <Typography className="noDataToDisplay">Select Options</Typography> */}
                                    <Typography className="noDataSubText">Please choose options to view EMIs</Typography>
                                </div>
                            )
                        }
                    </>
                    : (
                        <>
                            <Typography className="offerDetailsFieldTitle">EMI Tenure*</Typography>
                            <TableContainer component={Paper} style={{ marginTop: "8px" }}>
                                <Table>
                                    <TableHead sx={{ height: "46px" }}>
                                        <StyledTableHeadRow>
                                            <StyledTableCell>EMI Tenure</StyledTableCell>
                                            <StyledTableCell>Interest by Bank</StyledTableCell>
                                            <StyledTableCell>EMI Offer Type</StyledTableCell>
                                            <StyledTableCell>Interest borne by merchant</StyledTableCell>
                                            <StyledTableCell>Interest borne by customer</StyledTableCell>
                                        </StyledTableHeadRow>
                                    </TableHead>
                                    <TableBody>
                                        {emiData?.map((row, i) => (
                                            <StyledTableRow key={i} >
                                                <TableCell sx={{ width: "280px" }}
                                                    onClick={(e) => {
                                                        if (!isOfferAlreadyActive(row)) {
                                                            handleCheckboxChange(row?.emiMethod?.duration, e, !row.isChecked)
                                                        }
                                                    }}>
                                                    <div style={{ display: "flex", alignItems: "center", cursor: 'pointer' }}>
                                                        <Checkbox
                                                            checked={row.isChecked}
                                                            disabled={isOfferAlreadyActive(row)}
                                                        />
                                                        <span className="emiTenure">
                                                            {row?.emiMethod?.duration} {row?.emiMethod?.duration > 1 ? "Months" : "Month"}
                                                        </span>
                                                        {
                                                            isOfferAlreadyActive(row) && <span className="offerActive">OFFER ALREADY ACTIVE</span>
                                                        }
                                                    </div>
                                                </TableCell>

                                                <TableCell>{row?.emiMethod?.interestRate}%</TableCell>
                                                <TableCell sx={{ width: "200px" }}>
                                                    <Select
                                                        value={row?.offerType}
                                                        onChange={(e) => handleSelectChange(row?.emiMethod?.duration, 'offerType', e)}
                                                        disabled={!row?.isChecked || isOfferAlreadyActive(row)}
                                                        fullWidth
                                                    >
                                                        {
                                                            OFFER_TYPE.map((item, i) => <MenuItem value={item.value} key={`${item.value}`}>{item.title}</MenuItem>)
                                                        }
                                                    </Select>
                                                </TableCell>

                                                <TableCell>
                                                    <TextField
                                                        value={`${row?.emiMethod?.merchantBorneInterestRate}${row?.emiMethod?.isPercentageAdded ? "%" : ""}`}
                                                        onChange={(e) => handleTextFieldChange(row?.emiMethod?.duration, 'merchantBorneInterestRate', e)}
                                                        onBlur={(e) => {
                                                            handleTextFieldBlur(row?.emiMethod?.duration, 'merchantBorneInterestRate', e);
                                                            // row.emiMethod.isPercentageAdded = true;
                                                            // row.emiMethod.merchantBorneInterestRate = e.target.value.replace('%', '');
                                                        }}
                                                        onFocus={(e) => {
                                                            handleTextFieldFocus(row?.emiMethod?.duration, 'merchantBorneInterestRate', e);
                                                            // Remove % symbol on focus
                                                            // row.emiMethod.isPercentageAdded = false;
                                                            // row.emiMethod.merchantBorneInterestRate = e.target.value.replace('%', '');
                                                        }}
                                                        disabled={isOfferAlreadyActive(row) || isFieldDisabled(row)}
                                                        variant="outlined"
                                                        size="small"
                                                        fullWidth
                                                        error={Number(row?.emiMethod?.merchantBorneInterestRate) > row?.emiMethod?.interestRate}
                                                        style={{ backgroundColor: (isFieldDisabled(row)) && "rgba(230, 230, 230, 1)" }}
                                                    />
                                                </TableCell>
                                                <TableCell>
                                                    <TextField
                                                        value={
                                                            `${(Number(row?.emiMethod?.interestRate) - Number(row?.emiMethod?.merchantBorneInterestRate))
                                                                .toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 })}%`
                                                        }
                                                        disabled={true}
                                                        variant="outlined"
                                                        size="small"
                                                        fullWidth
                                                        style={{ backgroundColor: "rgba(230, 230, 230, 1)" }}
                                                    />
                                                </TableCell>
                                            </StyledTableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </>
                    )
            }

            {/* {emiPlanTableData && emiData?.length && offerFieldData?.selectedEmiOption && offerFieldData?.selectedIssuer ?
                <>
                    <Typography className="offerDetailsFieldTitle">EMI Tenure*</Typography>
                    <TableContainer component={Paper} style={{ marginTop: "8px" }}>
                        <Table>
                            <TableHead sx={{ height: "46px" }}>
                                <StyledTableHeadRow>
                                    <StyledTableCell>EMI Tenure</StyledTableCell>
                                    <StyledTableCell>Interest by Bank</StyledTableCell>
                                    <StyledTableCell>EMI Offer Type</StyledTableCell>
                                    <StyledTableCell>Interest borne by merchant</StyledTableCell>
                                    <StyledTableCell>Interest borne by customer</StyledTableCell>
                                </StyledTableHeadRow>
                            </TableHead>
                            <TableBody>
                                {emiData?.map((row, i) => (
                                    <StyledTableRow key={i} >
                                        <TableCell sx={{ width: "280px" }}
                                            onClick={(e) => {
                                                if (!isOfferAlreadyActive(row)) {
                                                    handleCheckboxChange(row?.emiMethod?.duration, e, !row.isChecked)
                                                }
                                            }}>
                                            <div style={{ display: "flex", alignItems: "center", cursor: 'pointer' }}>
                                                <Checkbox
                                                    checked={row.isChecked}
                                                    disabled={isOfferAlreadyActive(row)}
                                                />
                                                <span className="emiTenure">
                                                    {row?.emiMethod?.duration} {row?.emiMethod?.duration > 1 ? "Months" : "Month"}
                                                </span>
                                                {
                                                    isOfferAlreadyActive(row) && <span className="offerActive">OFFER ALREADY ACTIVE</span>
                                                }
                                            </div>
                                        </TableCell>

                                        <TableCell>{row?.emiMethod?.interestRate}%</TableCell>
                                        <TableCell sx={{ width: "200px" }}>
                                            <Select
                                                value={row?.offerType}
                                                onChange={(e) => handleSelectChange(row?.emiMethod?.duration, 'offerType', e)}
                                                disabled={!row?.isChecked || isOfferAlreadyActive(row)}
                                                fullWidth
                                            >
                                                {
                                                    OFFER_TYPE.map((item, i) => <MenuItem value={item.value} key={`${item.value}`}>{item.title}</MenuItem>)
                                                }
                                            </Select>
                                        </TableCell>

                                        <TableCell>
                                            <TextField
                                                value={`${row?.emiMethod?.merchantBorneInterestRate}${row?.emiMethod?.isPercentageAdded ? "%" : ""}`}
                                                onChange={(e) => handleTextFieldChange(row?.emiMethod?.duration, 'merchantBorneInterestRate', e)}
                                                onBlur={(e) => {
                                                    handleTextFieldBlur(row?.emiMethod?.duration, 'merchantBorneInterestRate', e);
                                                    // row.emiMethod.isPercentageAdded = true;
                                                    // row.emiMethod.merchantBorneInterestRate = e.target.value.replace('%', '');
                                                }}
                                                onFocus={(e) => {
                                                    handleTextFieldFocus(row?.emiMethod?.duration, 'merchantBorneInterestRate', e);
                                                    // Remove % symbol on focus
                                                    // row.emiMethod.isPercentageAdded = false;
                                                    // row.emiMethod.merchantBorneInterestRate = e.target.value.replace('%', '');
                                                }}
                                                disabled={isOfferAlreadyActive(row) || isFieldDisabled(row)}
                                                variant="outlined"
                                                size="small"
                                                fullWidth
                                                error={Number(row?.emiMethod?.merchantBorneInterestRate) > row?.emiMethod?.interestRate}
                                                style={{ backgroundColor: (isFieldDisabled(row)) && "rgba(230, 230, 230, 1)" }}
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <TextField
                                                value={
                                                    `${(Number(row?.emiMethod?.interestRate) - Number(row?.emiMethod?.merchantBorneInterestRate))
                                                        .toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 })}%`
                                                }
                                                disabled={true}
                                                variant="outlined"
                                                size="small"
                                                fullWidth
                                                style={{ backgroundColor: "rgba(230, 230, 230, 1)" }}
                                            />
                                        </TableCell>
                                    </StyledTableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </> :
                <div className="noDataDiv">
                    <Typography className="noDataToDisplay">No EMI Options Available--</Typography>
                    <Typography className="noDataSubText"> Please choose a different EMI type or issuer to see available options.</Typography>
                </div>
            } */}
        </div>
    )
}